import AdminAddDashboardsSubsubarea from '@src/main/ui/components/AdminAddDashboards/AdminAddDashboardsSubsubarea';
import { type FC } from 'react';

const AdminAddDashboardsSubsubareaPage: FC = () => <AdminAddDashboardsSubsubarea />;

export default AdminAddDashboardsSubsubareaPage;
